// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"ff3a8207","796":"d37b486c"}[chunkId] + ".chunk.js";
};